export default __webpack_public_path__ + "assets/jumbotron-720w.2b4517f5.png";